// src/services/pricingProxyService.js
// MGMT-FRONTEND-PRICING-VIA-PROXY-01. Experience pricing admin calls go through mgmt-backend's
// proxy (routes/pricingProxyRoutes.js), which adds whook's internal key server side, so no whook
// address and no key live in the panel for an admin pricing call. Same idiom as
// trendProxyService: T6_BASE + Firebase ID token in an Authorization: Bearer header.
//   GET    /api/pricing/admin/costs       ?includeInactive
//   POST   /api/pricing/admin/costs       <create body>
//   PUT    /api/pricing/admin/costs/:id   <update body>
//   DELETE /api/pricing/admin/costs/:id   ?hard=true for a hard delete
// SEC3 gates the admin reads too (they return cost and margin fields). The public
// GET /v1/agent/pricing/sports fallback stays on whook directly.

import axios from 'axios';
import { T6_BASE, authHeader } from '../pages/enterprise/EnterpriseAgentAccessTab';

const COSTS = `${T6_BASE}/api/pricing/admin/costs`;

async function send(method, url, body) {
    const res = await axios({ method, url, data: body, headers: await authHeader() });
    return res.data;
}

export const listPricingCosts = () => send('get', COSTS);

export const createPricingCost = (body) => send('post', COSTS, body);

export const updatePricingCost = (id, body) =>
    send('put', `${COSTS}/${encodeURIComponent(id)}`, body);

export const deletePricingCost = (id) =>
    send('delete', `${COSTS}/${encodeURIComponent(id)}`);

// The line the page's error Alert shows. whook pass-throughs carry `error`; a 502/503 from the
// proxy carries whook's (or the proxy's) sentence in `message`; the staff guard carries a code.
export function pricingActionError(err, fallback) {
    const data = err && err.response && err.response.data;
    return (data && (data.error || data.message)) || fallback;
}
